{
  "name": "hey-bible",
  "version": "2.6.0",
  "author": "bobby@workingdevshero.com",
  "homepage": "https://heybible.app",
  "database": "hey-bible",
  "scripts": {
    "ng": "ng",
    "start": "concurrently \"npx supabase start && npm run start:functions\" \"ng serve --configuration local\" \"npx wait-on http://localhost:4200 && open http://localhost:4200\"",
    "start:prod": "ng serve --configuration production",
    "serve:verify": "ng serve --configuration verify --port 4200",
    "start:ios": "ionic capacitor build ios --source-map",
    "poststart:ios": "npm run sourcemaps",
    "start:ios-local": "ng build --configuration ios-local && npx cap sync ios && npx cap open ios",
    "serve:lan": "ng serve --host 0.0.0.0 --configuration ios-local",
    "start:android": "ionic capacitor build android --source-map",
    "poststart:android": "npm run sourcemaps",
    "start:functions": "npx supabase functions serve --env-file supabase/functions/.env",
    "debug:functions": "npx supabase functions serve --inspect-mode brk --env-file supabase/functions/.env",
    "tunnel": "ngrok http 54321 --url=https://hey-bible.ngrok.io",
    "email:local": "open \"http://localhost:54324/\"",
    "studio:local": "open \"http://localhost:54323/\"",
    "build:prod": "ng build --configuration production",
    "postbuild:prod": "npm run sourcemaps",
    "db:reset": "npx supabase db reset",
    "db:push": "npx supabase db push",
    "db:pull": "npx supabase db pull",
    "db:seed": "ts-node supabase/data/create.ts",
    "db:stop": "npx supabase stop",
    "db:types": "npx supabase gen types typescript --local > supabase/types/supabase.ts && cp supabase/types/supabase.ts supabase/functions/_shared/supabase.ts",
    "sourcemaps": "node -r dotenv/config $(which npx) @bugsplat/symbol-upload -d ./www/browser",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test --no-watch",
    "lint": "export NODE_OPTIONS='--max-old-space-size=16384' && ng lint  --fix --cache"
  },
  "private": true,
  "engines": {
    "node": "^24.15.0"
  },
  "dependencies": {
    "@angular/animations": "^22.1.4",
    "@angular/cdk": "^22.1.4",
    "@angular/common": "^22.1.4",
    "@angular/compiler": "^22.1.4",
    "@angular/core": "^22.1.4",
    "@angular/forms": "^22.1.4",
    "@angular/platform-browser": "^22.1.4",
    "@angular/platform-browser-dynamic": "^22.1.4",
    "@angular/router": "^22.1.4",
    "@capacitor/android": "^8.0.0",
    "@capacitor/app": "^8.0.0",
    "@capacitor/browser": "^8.0.0",
    "@capacitor/camera": "^8.0.0",
    "@capacitor/clipboard": "^8.0.0",
    "@capacitor/core": "^8.0.0",
    "@capacitor/haptics": "^8.0.0",
    "@capacitor/ios": "^8.0.0",
    "@capacitor/keyboard": "^8.0.0",
    "@capacitor/screen-orientation": "^8.0.0",
    "@capacitor/status-bar": "^8.0.0",
    "@capgo/capacitor-social-login": "^7.11.0",
    "@capgo/native-purchases": "^7.16.0",
    "@hey-bible/bible-reference-parser": "^4.0.0",
    "@ionic/angular": "^9.0.1",
    "@ionic/pwa-elements": "^3.3.0",
    "@ionic/storage-angular": "^4.0.0",
    "@ngneat/error-tailor": "^5.0.1",
    "@supabase/supabase-js": "^2.106.2",
    "bugsplat-ng": "^18.0.1",
    "ionicons": "^8.0.13",
    "marked": "^18.0.5",
    "ngx-markdown": "^22.0.0",
    "openmoji": "^16.0.0",
    "rxjs": "~7.8.2",
    "title-case": "^4.3.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.0.0",
    "@angular-eslint/eslint-plugin": "^22.0.0",
    "@angular-eslint/eslint-plugin-template": "^22.0.0",
    "@angular-eslint/schematics": "^22.0.0",
    "@angular-eslint/template-parser": "^22.0.0",
    "@angular/build": "^22.1.6",
    "@angular/cli": "^22.1.6",
    "@angular/compiler-cli": "^22.1.4",
    "@angular/language-service": "^22.1.4",
    "@bugsplat/symbol-upload": "^11.0.0",
    "@bugsplat/vitest-auto-spies": "^1.0.0",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.0.0",
    "@ionic/angular-toolkit": "^13.0.0",
    "@types/node": "^24.3.0",
    "@typescript-eslint/eslint-plugin": "^8.62.0",
    "@typescript-eslint/parser": "^8.62.0",
    "@typescript-eslint/types": "^8.62.0",
    "@typescript-eslint/utils": "^8.62.0",
    "angular-eslint": "^22.0.0",
    "concurrently": "^9.2.1",
    "dotenv": "^17.2.1",
    "eslint": "^9.34.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^54.1.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^29.1.1",
    "ng-mocks": "^14.15.3",
    "supabase": "^2.108.0",
    "ts-node": "^10.9.2",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.62.0",
    "vitest": "^4.0.8",
    "wait-on": "^9.1.0"
  },
  "description": "Your friendly Bible companion"
}
